<template>
  <div>
    <!-- 头部 开始 -->
    <header class="module-layer-mobile">
      <div class="module-layer-content-mobile">
        <div class="back" @click="back">
          <p class="iconfont">&#xe685; 详情</p>
        </div>
      </div>
    </header>
    <!-- 头部 结束 -->

    <!-- 主体 开始 -->
    <div class="layout-container">
      <div class="cp_parta">
        <div class="cp_content02">
          <div class="cp_blk03">
            <a class="return" @click="prev" href="#">
              <span>
                <i class="iconfont">&#xe685;</i>
              </span>返回上页
            </a>
            <div class="cp_blk03_main">
              <div class="cp_b03_info">
                <div class="cp_b03_info_height">
                  <el-image style="width:100%;height:auto;" :src="item.picture_url"></el-image>
                </div>
              </div>
              <div class="cp_b03_info2">
                <div class="parta info">
                  <h2>{{ item.name }}</h2>
                  <div class="pa_main">
                    <div class="tit_box">
                      <div class="ul_box">
                        <ul>
                          <li>
                            <span>文物号</span>
                            <p>{{ item.number }}</p>
                          </li>
                          <li>
                            <span>分类</span>
                            <p>{{ item.category_name }}</p>
                          </li>
                          <li>
                            <span>年代</span>
                            <p>{{ item.dynasty }}</p>
                          </li>
                          <li>
                            <span>价格</span>
                            <p>{{ item.price }}</p>
                          </li>
                          <li>
                            <span>状态</span>
                            <p>{{ item.status_name }}</p>
                          </li>
                          <li>
                            <span>备注</span>
                            <p>{{ item.remark }}</p>
                          </li>
                        </ul>
                        <ul style=" padding:0 0 10px 0;">
                          <li id="show_more"></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="cp_blk03_main02">
              <div class="cp_blk03_main02_info">
                <h2>文字信息</h2>
                <p>{{ item.desc }}</p>
              </div>

              <div class="height01" style="height:40px; overflow:hidden;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主体 结束 -->
  </div>
</template>

<script>
import { getProductDetail } from "@/api/api";
export default {
  data() {
    return {
      id: "",
      item: []
    };
  },
  created() {
    // example 127.0.0.1/list/1, id = 1
    this.id = this.$route.params && this.$route.params.id;
    this.fetchData(this.id);
  },
  methods: {
    prev() {
      // 返回上一页
      console.log("点击回退按钮");
      this.$router.go(-1);
    },
    back() {
      // 返回上一页
      this.$router.push({
        path: `/list/${this.item.category_id}`
      });
    },
    fetchData(id) {
      getProductDetail(id).then(response => {
        this.item = response.data;
      });
    }
  }
};
</script>

<style scoped>
.back p {
  color: #c1925b;
}
.cp_b03_info_height {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.cp_b03_info_height /deep/ .el-image__error {
  display: none;
}
</style>